import clsx from "clsx";
import { SnackbarProvider } from "notistack";
import { FC, PropsWithChildren } from "react";

import { useContextSupportMessenger } from "@/context/support_messenger";

import { ButtonClose } from "./button_close";
import classes from "./snackbar.module.css";

export const ProviderSnackbar: FC<PropsWithChildren> = ({ children }) => {
  const {
    state: { isInited: isMessengerInited },
  } = useContextSupportMessenger();

  return (
    <SnackbarProvider
      action={(key) => <ButtonClose id={key} />}
      anchorOrigin={{
        horizontal: "right",
        vertical: "bottom",
      }}
      classes={{
        containerRoot: clsx(
          classes.containerRoot,
          isMessengerInited && classes.containerRoot_with_messenger,
        ),
        root: classes.root,
      }}
      dense={true}
      maxSnack={3}
    >
      {children}
    </SnackbarProvider>
  );
};
